import styled from 'styled-components';

export const wrapInput = styled.div`
      padding: 10px 0;
      display: grid; 
      ${p=>p.inputStyle}
`;